import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OffClickDirective } from './directives/off-click.directive';

import { TreeSelectComponent } from './tree-select.component';
import { TreeSelectItemComponent } from './tree-select-item.component';


import { TreeSelectDefaultOptions } from './models/tree-select-default-options';
import { ItemPipe } from './item.pipe';

export const COMPONENTS = [TreeSelectComponent, TreeSelectItemComponent];

@NgModule({
  declarations: [...COMPONENTS, OffClickDirective, ItemPipe],
  imports: [CommonModule, FormsModule],
  exports: [...COMPONENTS],
  entryComponents: [...COMPONENTS],
  providers: [TreeSelectDefaultOptions],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TreeSelectModule {
  public static forRoot(options: TreeSelectDefaultOptions): ModuleWithProviders {
    return {
      ngModule: TreeSelectModule,
      providers: [
        { provide: TreeSelectDefaultOptions, useValue: options }
      ]
    };
  }
}
